// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"177":"home","187":"NotFound","443":"about","631":"contact","821":"pagina"}[chunkId] || chunkId) + "-legacy." + {"69":"10c2ef26","177":"4186f66f","187":"5fa5f74f","443":"a25ee8b1","631":"cce9b4c7","708":"ff5ff3b3","821":"abe98f80"}[chunkId] + ".js";
};